import React from 'react';

/**
 * Components
 */
import Select, { selectType } from 'Components/Select';
import DatePicker from 'Components/DatePicker';

export default ({
  inputErrors,
  handleSelect,
  handleYearSelect,
  yearsList,
  reportYear,
  monthsList,
  reportDate,
  isHistoric,
  handleDateChoose,
}) => {
  return (
    <section className='report-filters-section'>
      <header>Report Filters</header>
      <div className='filters-fields-wrapper'>
        <Select
          selectionList={yearsList}
          defaultItem={reportYear}
          type={selectType.primary}
          mainWrapperClassName='_margin_top_0 _margin_right_30'
          label='Model Year *'
          error={inputErrors.reportYear}
          withoutSearch
          handleSelect={handleYearSelect}
        />
        <DatePicker
          error={inputErrors.reportDate}
          selectedDate={reportDate}
          handleSelectDate={handleDateChoose}
          mainWrapperClassName='_margin_top_12'
        />
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ReportScene/HistoricMMLReport/index.jsx